import type { Media } from '@/payload/payload.types';

export const isMedia = <T extends Media | null | number | undefined>(
  value: T,
): NonNullable<Media> | undefined => {
  if (typeof value === 'object') {
    return value as NonNullable<Media>;
  }

  return;
};
